import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions/';

class Signup extends Component {

  handleFormSubmit(formProps) {
    // Call action creator to sign up the user
    this.props.signupUser(formProps, () => this.props.history.push('/dashboard'));
  }

  renderField({ input, label, type, meta: { touched, error } }) {

    const className = `form-group ${touched && error ? 'has-danger': ''}`;

    return(
      <fieldset className={className}>
        <label>{label}</label>
        <input {...input} placeholder={label} type={type} className="form-control" />
        {touched && error && <div className="text-danger">{error}</div>}
      </fieldset>
    );
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return(
        <div className="alert alert-danger">
          <strong>Error:</strong> {this.props.errorMessage}
        </div>
      );
    }
  }

  render() {
    const { handleSubmit } = this.props;

    return(
      <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
        <Field name="email" label="Email" component={this.renderField} type="text" />
        <Field name="password" label="Password" component={this.renderField} type="password" />
        <Field name="confirmPassword" label="Confirm Password" component={this.renderField} type="password" />
        {this.renderAlert()}
        <button action="submit" className="btn btn-primary">Sign up</button>
      </form>
    );
  }
}

function validate(values) {
  const errors = {};

  if (!values.email) {
    errors.email = 'Enter an email';
  }

  if (!values.password) {
    errors.password = 'Enter a password';
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = 'Enter a password';
  }

  if (values.password !== values.confirmPassword) {
    errors.password = 'Passwords must match';
  }

  // If errors is empty, form is ok to submit
  return errors;
}

const signupForm = reduxForm({
  form: 'signup',
  validate
})(Signup);

function mapStateToProps(state) {
  return { errorMessage: state.auth.error };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(signupForm);



// WEBPACK FOOTER //
// ./src/containers/auth/signup.js